import NewsItemHeader from './NewsItemHeader'
import NewsItemHeaderLoading from './NewsItemHeaderLoading'

export { NewsItemHeaderLoading }
export default NewsItemHeader
